var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"img-background"},[_c('img',{attrs:{"src":_vm.material.icon}})]),_c('div',{staticClass:"content__container"},[_c('p',[_vm._v(_vm._s(_vm.material.title))]),_c('a',{attrs:{"href":_vm.material.link}},[_vm._v(" "+_vm._s(_vm.material.link_title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }